export default __webpack_public_path__ + "d6bc9c75dc79846b22c099d5aca76000.png";